import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from 'ionic-appauth-custom';
import { NavController } from '@ionic/angular';
import {UserService} from '../../user.service';
import {ConnectivityService} from '../../connectivity.service';
import { filter, switchMap, tap } from 'rxjs/operators';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService  {

    private checkAuth = this.auth.initComplete$.pipe(
        filter(complete => complete),
        switchMap(() => this.auth.isAuthenticated$),
        tap(isAuthenticated => {
            if (!isAuthenticated) {
                console.log('Not authenticated!');
                this.navCtrl.navigateRoot('landing').then();
            }
        }),
    );

  constructor(
    private auth: AuthService,
    private navCtrl: NavController,
    private userService: UserService,
    private connectivityService: ConnectivityService
    ) { }

  // public async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
  //   console.log('Authguard checks if we can come in.');
  //   let authResult;
  //   try {
  //     authResult = await this.auth.initComplete$.pipe(
  //         filter(complete => complete),
  //         switchMap(() => this.auth.isAuthenticated$),
  //         tap(isAuthenticated => {
  //           if(!isAuthenticated) {
  //             console.log('Somehow not authenticated');
  //           }
  //         }),
  //     ).toPromise();
  //   } catch {
  //     authResult = false;
  //   }
  //   console.log('Received result:', authResult);
  //   const isAuthenticated = (authResult && this.userService.serviceReady) || !this.connectivityService.appIsOnline;
  //   if (!isAuthenticated) {
  //     this.navCtrl.navigateRoot('landing').then();
  //   }
  //   console.log('Authguard says:', isAuthenticated);
  //   return isAuthenticated;
  // }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
      console.log('AuthGuard reached!', route, state);
      if (!this.connectivityService.appIsOnline) { return true; }
      // In case user service is not yet ready, wait for it and then check if user is authenticated
      if (!this.userService.serviceReady) {
          return this.userService.serviceReadySubject.asObservable().pipe(
              filter(val => val),
              switchMap(() => this.checkAuth));
      }
      // In case user service is already ready, just check auth
      return this.userService.user?.isLocalUser || this.checkAuth;
  }
}
